
export async function loadPolandMapData() {
    try {
        const response = await fetch('https://code.highcharts.com/mapdata/countries/pl/pl-all.topo.json');
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const mapData = await response.json();
        return mapData;
    } catch (error) {
        console.warn('Nie udało się załadować mapy Polski:', error.message);
        return null;
    }
}
